// @flow

import React, { type Node } from 'react';

import { DisplayExpiration } from './display-expiration';
import { DisplayTotalAmount } from './display-total-amount';

import { QrCode } from './qr-code';
import { Separator } from '../../../../../../atoms';
import { theme } from '../../../../../../theme';

export function Ticket(): Node {

  return (
    <div style={Root}>
      <div style={PaymentInfoWrapper}>
        <DisplayTotalAmount />
        <DisplayExpiration />
      </div>
      <Separator pattern="dashed" direction="vertical" size={5.5} />
      <div style={Title}>Pague com Pix</div>
      <div style={Subtitle}>Use o app do seu banco ou carteira digital para escanear o código QR abaixo:</div>
      <QrCode />
    </div>);
}

const Title = {
  fontFamily: theme.fontFamily.display,
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '18px',
  textAlign: 'center',
  color: '#738093',
  marginBottom: '13px',
};

const Subtitle = {
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '14px',
  textAlign: 'center',
  marginBottom: '12px',
  maxWidth: '345px',
  color: '#666666',
};

const Root = {
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const PaymentInfoWrapper = {
  display:' flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  background: '#f8f8f9',
  width: '100%',
  margin: '15px',
};
